module.exports = __webpack_public_path__ + "img/109.635711de.jpg";